<div class="wrapper charts container-fluid">
  <div class="card">
    <div class="chart_row row m-0">
      <h4>Customer Emotional Analysis</h4>
      <div class="chart_column col-8">
        <div class="details_row row">
          <h4 class="details_column col">
            <span class="details_title">Name: </span>Ravi raj
          </h4>
          <h4 class="details_column col">
            <span class="details_title">Gender: </span>Male
          </h4>
          <h4 class="details_column col">
            <span class="details_title">Age: </span>25yrs
          </h4>
        </div>
        <canvas
          class="chart pb-5"
          baseChart
          [datasets]="emotionAnalysisdataSets"
          [labels]="emotionAnalysislables"
          [legend]="emotionAnalysislegend"
          [options]="emotionAnalysisoptions"
          [type]="'line'"
        >
        </canvas>
      </div>
      <div class="chart_column col-4">
        <ul class="emotions card">
          <li
            class="emotion card-header"
            *ngFor="let emotion of emotions; let i = index"
          >
            <span class="emotion_type">
              <img class="emotion_icon" [src]="emotion.imgUrl" alt="icon" />
              <h6 class="emotion_name">{{ emotion.name }}</h6>
            </span>
            <h1 class="emotion_value" [ngStyle]="{ color: i | color }">
              {{ emotion.per }}%
            </h1>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
